import React from 'react';
import { Button } from '../ui/Button';
import { useDrawers } from '../../contexts/DrawerContext';
import { FileText, Star } from 'lucide-react';
export function Hero() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <section className="relative overflow-hidden bg-background pt-10 md:pt-16 pb-20 md:pb-28" data-id="element-268">
      {/* warm wash behind the content */}
      <div className="absolute inset-0 -z-10" style={{
      background: 'radial-gradient(820px 460px at 8% 0%, var(--accent-soft) 0%, rgba(251,246,238,0) 58%), radial-gradient(680px 480px at 100% 18%, var(--cream) 0%, rgba(251,246,238,0) 62%)'
    }} aria-hidden="true" data-id="element-269" />
      <div className="max-w-7xl mx-auto px-5 md:px-6" data-id="element-270">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center" data-id="element-271">
          {/* Copy */}
          <div className="lg:col-span-6 animate-rise" data-id="element-272">
            <span className="inline-flex items-center gap-2 rounded-full bg-surface border border-border shadow-card px-4 py-1.5 text-xs font-semibold tracking-wide uppercase text-ink/80" data-id="element-273">
              <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-274" />
              Property Law & Conveyancing · Carlton, Melbourne
            </span>

            <h1 className="mt-6 font-serif text-ink text-[2.7rem] leading-[1.04] sm:text-[3.4rem] lg:text-[4.4rem] lg:leading-[1.02] tracking-tight" data-id="element-275">
              Clear legal advice before you{' '}
              <span className="relative whitespace-nowrap text-accent" data-id="element-276">
                buy, sell or sign
                <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 300 12" fill="none" preserveAspectRatio="none" aria-hidden="true" data-id="element-277">
                  <path d="M2 8C60 3 140 3 298 7" stroke="var(--accent)" strokeWidth="4" strokeLinecap="round" opacity="0.7" data-id="element-278" />
                </svg>
              </span>
              .
            </h1>

            <p className="mt-6 text-lg md:text-xl text-muted-ink leading-relaxed max-w-xl" data-id="element-279">
              Lawyer-led conveyancing for Victorian property, from contract
              review and Section 32 advice through to a settlement that actually
              lands on time.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-280">
              <Button onClick={openUpload} variant="accent" size="lg" className="w-full sm:w-auto" data-id="element-281">
                <FileText className="w-5 h-5" data-id="element-282" />
                Upload a contract
              </Button>
              <Button onClick={openQuote} variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-283">
                Get a free quote
              </Button>
            </div>

            <p className="mt-4 text-sm text-muted-ink max-w-md" data-id="element-284">
              Have an auction, offer or signing deadline? Add it to your enquiry
              so the team can assess the urgency.
            </p>
          </div>

          {/* Imagery */}
          <div className="lg:col-span-6 animate-rise" style={{
          animationDelay: '0.12s'
        }} data-id="element-285">
            <div className="relative" data-id="element-286">
              {/* bold accent block behind for pop */}
              <div className="absolute -top-5 -right-4 w-40 h-40 rounded-3xl bg-accent/15 -z-10 hidden sm:block" aria-hidden="true" data-id="element-287" />
              <div className="absolute -bottom-8 -left-8 w-44 h-44 rounded-full bg-brand-blue/10 -z-10 hidden sm:block" aria-hidden="true" data-id="element-288" />

              <div className="overflow-hidden rounded-4xl shadow-warm ring-1 ring-black/5" data-id="element-289">
                <img src="https://images.unsplash.com/photo-1592595896551-12b371d546d5?auto=format&fit=crop&w=1100&q=80" alt="A Victorian terrace home on a leafy Carlton street in Melbourne" className="w-full h-[380px] md:h-[540px] object-cover" loading="eager" data-id="element-290" />
              </div>

              {/* Rating chip top-left */}
              <div className="absolute top-5 left-5 flex items-center gap-2 bg-surface/95 backdrop-blur rounded-full pl-2 pr-3.5 py-2 shadow-subtle border border-border" data-id="element-291">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-accent text-white" data-id="element-292">
                  <Star className="w-4 h-4" fill="currentColor" data-id="element-293" />
                </span>
                <span className="text-sm font-bold text-ink" data-id="element-294">5.0</span>
                <span className="text-xs text-muted-ink" data-id="element-295">· 10 reviews</span>
              </div>

              {/* Floating reassurance card */}
              <div className="absolute -bottom-6 -left-3 sm:left-6 bg-surface rounded-2xl shadow-subtle border border-border p-4 sm:p-5 max-w-[16rem]" data-id="element-296">
                <p className="font-serif text-lg text-ink leading-snug" data-id="element-297">
                  Reviewed before you sign
                </p>
                <p className="mt-1 text-sm text-muted-ink leading-relaxed" data-id="element-298">
                  Contracts and Section 32 statements read by a solicitor, not a
                  checklist.
                </p>
              </div>

              {/* badge bottom-right */}
              <div className="absolute bottom-6 right-5 bg-ink text-cream rounded-full px-4 py-2 text-xs font-semibold tracking-wide shadow-warm" data-id="element-299">
                Established Carlton practice
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}